import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  ListCitiesUseCasePort
} from '@features/setting/application/use_cases/list-cities/list-cities.use-case.port';
import {
  ListCitiesPayloadDto
} from '@features/setting/application/use_cases/list-cities/dto/list-cities.payload.dto';
import {
  ListCitiesResponseDto
} from '@features/setting/application/use_cases/list-cities/dto/list-cities.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  ListCitiesHttpPayloadDto
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.payload.dto';
import {
  ListCitiesHttpResponseDto
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.response.dto';
import {
  ListCitiesHttpMapper
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.mapper';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class ListCitiesHttpAdapter implements ListCitiesUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);
  private readonly navigationPort = inject(NavigationPort);

  public execute(payload: ListCitiesPayloadDto): Observable<ListCitiesResponseDto> {
    const url = window.location.href;
    const {suffix} = this.navigationPort.extractQueryParams(url);
    let suffixDatabase: string | null = null;
    if (!suffix) {
      suffixDatabase = this.localStoragePort.getByKey<string | null>('_suffix');
      if (!suffixDatabase) throw new Error(`Could not find suffix`);
    } else {
      suffixDatabase = suffix;
    }
    const filter: FilterInterface = {};
    const headers: HttpHeaders = new HttpHeaders({
      "token": environment.secret_key,
      "x-filter-model": JSON.stringify(filter),
    });
    return this.http.get<ListCitiesHttpResponseDto>(`${this.url}city-list?suffix_database=${suffixDatabase}`, {
      headers
    })
      .pipe(map(ListCitiesHttpMapper.toResponse)
      )
  }

}
